import dayjs from 'dayjs';
import { escapeHtml } from 'base/backbone/lib/utilities/helpers';

Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {
    var templateHelpers = {
        setDisplayOptions: function() {
            if (!this.displayOptions) {
                this.displayOptions = App.displayOptions.toJSON();
            }
        },
        userVotedSet: function() {
            var valueToFind = this.album_id + '_' + this.album_photo_id;
            var pixleeLikesContains = _.contains($.cookie('pixlee_likes'), valueToFind);
            var pixleeLegacyLikesContains = _.contains($.cookie('pixlee_likes_legacy'), valueToFind);

            return pixleeLikesContains || pixleeLegacyLikesContains;
        },

        getActionLink: function() {
            this.setDisplayOptions();
            if (!_.isFalsy(this.richAction) && !_.isFalsy(this.richAction.link)) {
                return this.richAction.link;
            }
            if (!_.isFalsy(this.action_link)) {
                return this.action_link;
            }
            if (!_.isFalsy(gon.current_album.action_link)) {
                return gon.current_album.action_link;
            }
            if (!_.isFalsy(gon.display_options.customCallToActionLink)) {
                return gon.display_options.customCallToActionLink;
            }
            return '';
        },
        getVotedText: function() {
            if (!_.isFalsy(gon.display_options.customVotedText)) {
                return gon.display_options.customVotedText;
            }
            return 'voted';
        },
        getActionText: function() {
            this.setDisplayOptions();
            if (!_.isFalsy(this.richAction) && !_.isFalsy(this.richAction.action_link_text)) {
                return this.richAction.action_link_text;
            }
            if (!_.isFalsy(this.action_link_text)) {
                return this.action_link_text;
            }
            if (!_.isFalsy(gon.current_album.action_link_text)) {
                return gon.current_album.action_link_text;
            }
            if (!_.isFalsy(gon.display_options.customCallToActionText)) {
                return gon.display_options.customCallToActionText;
            }
            return '';
        },
        hasActionLink: function() {
            this.setDisplayOptions();
            if (gon.current_account.id === 553) {
                return false;
            }
            var currentUserModel = App.currentUser;
            if (currentUserModel.canAccess('ecomm')) {
                return true;
            } else if (!_.isFalsy(this.action_link_title) && !_.isFalsy(this.action_link_photo)) {
                return true;
            } else if (gon.display_options.customCallToActionPhoto) {
                return true;
            }
            if (
                this.displayOptions.showCallToAction &&
                !_.isFalsy(this.displayOptions.customCallToActionText) &&
                !_.isFalsy(this.displayOptions.customCallToActionLink)
            ) {
                return true;
            } else if (
                !_.isFalsy(this.action_link_text) &&
                !_.isFalsy(this.action_link) &&
                gon.display_options.showCallToAction
            ) {
                return true;
            }
            if (!_.isFalsy(this.action_link)) {
                return true;
            }
            if (!_.isFalsy(gon.current_album.action_link)) {
                return true;
            }
            return false;
        },
        showCommunityBadge: function() {
            // If the content is tagged with a category of "community" then its community content
            // The gallery must also have the community display option enabled
            var isCommunity = _.some(this.categories, function(category) {
                return category.toLowerCase() === 'community';
            });
            return isCommunity && gon.display_options.showCommunityBadge;
        },
        submitterType: function() {
            if (_.isFalsy(this.source)) {
                return 'desktop';
            }
            return this.source;
        },
        // Get content source class name in html.erb. Community content cant still
        // be IG but we replace the IG Icon with the community badge.
        contentSourceClass: function() {
            if (this.showCommunityBadge()) {
                return 'community';
            }
            return this.submitterType();
        },

        /**
         * Instagram often generates errors if its URLs don't end with a slash, so we ensure they always have one.
         */
        getPlatformLink: function() {
            if ('instagram' === this.submitterType() && this.platform_link) {
                return this.platform_link.slice(-1) === '/' ? this.platform_link : this.platform_link + '/';
            } else {
                return this.platform_link;
            }
        },

        /**
         *
         * @param {boolean} isWidgetPhoto is this being laoded from a widget
         */
        submitterAnchor: function(isWidgetPhoto) {
            switch (this.submitterType()) {
                case 'instagram':
                    var classNames = '';
                    var href = 'http: //instagram.com/' + this.submitter().replace('@', '');
                    var anchorText = '@' + this.submitter().replace('@', '');
                    var tooltip = '';

                    if (!this.connected_user_id) {
                    // CP uses font awesome as icon tags, but photos uses it via CSS
                    // TODO: use localization when its available
                        var anonUserHtml = '<i class="fas fa-user-circle"></i><span>Unknown User</span>';
                        anchorText = isWidgetPhoto ? 'Instagram User' : anonUserHtml;
                        classNames = 'instagram handle anonymous_instagram tooltip_component';
                        tooltip = (
                            'data-tooltip-text="Instagram’s API does not provide user information ' +
                            'for content collected via hashtag."'
                        );
                    } else {
                        if (this.content_type === 'image' || !this.content_type) {
                            classNames = 'instagram handle';
                        } else {
                            classNames = 'instagram_video handle';
                        }
                    }
                    return (
                        '<a class="' + classNames + '" href="' + this.getPlatformLink() + '" target="_blank"' +
                        tooltip + '>' + anchorText + '</a>'
                    );
                case 'twitter':
                    if (this.content_type === 'image' || !this.content_type) {
                        if (!_.isFalsy(this.platform_link)) {
                            return (
                                '<a class="twitter handle" href="' + this.platform_link +
                                '" target="_blank">@' + this.submitter().replace('@', '') + '</a>'
                            );
                        }
                        return '<a class="twitter handle" href="http://twitter.com/' + this.submitter().replace('@', '') + '" target="_blank">@' + this.submitter().replace('@', '') + '</a>';
                    }
                    if (!_.isFalsy(this.platform_link)) {
                        return (
                            '<a class="vine handle" href="' + this.platform_link + '" target="_blank">@' +
                            this.submitter().replace('@', '') + '</a>'
                        );
                    }
                    return '<a class="vine handle">' + this.submitter() + '</a>';
                case 'website':
                    return '<a class="website handle">' + this.submitter() + '</a>';
                case 'facebook':
                    return '<a class="facebook handle">' + this.submitter() + '</a>';
                case 'email':
                    if (isWidgetPhoto) {
                        return '<a class="email handle" ></a>';
                    }
                    return '<a class="email handle">' + this.submitter() + '</a>';
                case 'desktop':
                    return '<a class="email handle">' + this.submitter() + '</a>';
                case 'twitch':
                case 'tiktok':
                    return (
                        '<a class="' + this.submitterType() + ' handle" href="' + this.platform_link +
                        '" target="_blank">' + this.submitter() + '</a>'
                    );
                default:
                    return '<a class="submitted_by_you handle">' + this.submitter(isWidgetPhoto) + '</a>';
            }
        },
        submitter: function() {
            if (this.user_name != null) {
                return escapeHtml(this.user_name);
            }
            if (this.email_address != null && !App.isWidget) {
                return escapeHtml(this.email_address);
            }
            return '';
        },
        getTitle: function() {
            if (this.title && this.title !== 'null') {
                return this.title;
            }
            if (this.album_title && this.album_title !== 'null') {
                return this.album_title;
            }
            if (this.photo_title && this.photo_title !== 'null') {
                return this.photo_title;
            }
            return '';
        },
        altText: function() {
            var altText = '';
            if (!_.isFalsy(this.alt_text)) {
                altText = this.alt_text;
            } else {
                try {
                    if (!_.isFalsy(this.submitter())) {
                        altText += 'Photo taken by ' + escapeHtml(this.submitter()) + ' ';
                        if (!_.isFalsy(this.submitterType)) {
                            altText += 'on ' + escapeHtml(this.submitterType()) + ' ';
                        }
                    } else {
                        altText += 'Photo submission ';
                        if (!_.isFalsy(this.submitterType)) {
                            altText += 'to ' + escapeHtml(this.submitterType()) + ' ';
                        }
                    }
                    if (!_.isFalsy(this.getTitle())) {
                        altText += ' with the caption of: ' + escapeHtml(this.getTitle()) + '.';
                    }
                } catch (err) {
                    altText = '';
                }
            }
            return escapeHtml(altText);
        },
        uploaderAdditionalFields: function() {
            var fields = this.uploader_additional_fields;
            var result = '';

            if (!_.isEmpty(fields)) {
                //create a div for each additional field, with the key as an identifying class
                _.each(fields, function(field, index) {
                    index = index.split(' ')[0]; //first word only for multi-word named fields
                    result += '<div class="additional_upload_info ' + index + '">' + field + '</div>';
                });
            }

            return result;
        },
        photoURL: function(size) {
            if (this.data_file_name != null) {
                return this.photoFileURL(size);
            }
            switch (this.submitterType()) {
                case 'instagram':
                    if (this.content_type === 'image' || !this.content_type) {
                        if (this.source_url != null) {
                            return this.source_url.replace('http://', 'https://');
                        }
                    } else if (this.content_type === 'video') {
                        return this.thumbnail_url.replace('http://', 'https://');
                    }
                    break;
                case 'facebook':
                    if (this.source_url != null) {
                        return this.source_url.replace('http://', 'https://');
                    }
                    break;
                case 'website':
                    if (this.source_url != null) {
                        return this.source_url.replace('http://', 'https://');
                    }
                    break;
                case 'email':
                    if (this.source_url != null) {
                        return this.source_url.replace('http://', 'https://');
                    }
                    break;
                case 'desktop':
                    if (this.source_url != null) {
                        return this.source_url.replace('http://', 'https://');
                    }
                    break;
                case 'twitter':
                    if (this.content_type === 'image' || !this.content_type) {
                        if (this.source_url != null) {
                            return this.source_url.replace('http://', 'https://');
                        }
                    } else if (this.content_type === 'video') {
                        return this.thumbnail_url.replace('http://', 'https://');
                    }
                    break;
                default:
                    if (this.source_url != null) {
                        return this.source_url.replace('http://', 'https://');
                    }
                    break;
            }
            return '';
        },
        /**
         * Specifically For thumbnail versions of a photo.
         * Does not look into the /size folders for larger images
         */
        getThumbnailPhotoURL: function() {
            if (this.content_type === 'video') {
                return this.thumbnail_url;
            }
            var photoId = this.id || this.photo_id;
            var fileName = this.data_file_name;
            var encodedFilename = App.reqres.request('encode:utf8', fileName);
            var hostName = 'https://static.pxlecdn.com';
            var subDirectory = this.approved ? '/thumb/' : '/original/';
            if (this.config && this.config.env === 'development') {
                var bucket = 'pixlee-dev';
                hostName = 'http://s3.amazonaws.com/' + bucket;
            }
            return hostName + '/photos/' + photoId + subDirectory + encodedFilename;
        },
        /**
         * @param {string} [size] original | medium
         */
        photoFileURL: function(size) {
            size = size || 'medium';
            var photoId = this.id || this.photo_id;
            var fileName = this.data_file_name;
            var encodedFilename = App.reqres.request('encode:utf8', fileName);
            var hostName = 'https://static.pxlecdn.com';

            if (this.config && this.config.env === 'development') {
                var bucket = 'pixlee-dev';
                hostName = 'http://s3.amazonaws.com/' + bucket;
            }
            return hostName + '/photos/' + photoId + '/' + size + '/' + encodedFilename;
        },
        dedicatedLink: function() {
            return (
                gon.global.pixleePhotosServer + this.currentUser.id + '/' + this.album_id + '/' + this.album_photo_id
            );
        },
        dedicatedPath: function() {
            return '/' + this.currentUser.id + '/' + this.album_id + '/' + this.album_photo_id;
        },
        videoURL: function() {
            return this.source_url.replace('http://', 'https://');
        },
        isVideo: function() {
            if (this.content_type === 'video') {
                return true;
            }
            return false;
        },
        isStory: function() {
            return this.subtype === 'instagram_story';
        },
        shouldShowCaptions: function() {
            return true;
        },
        getCustomVideoThumbnail: function() {
            // If there is a custom thumbnail in video settings, return it as the thumbnail
            var videoSettings = this.video_settings || {};
            return !_.isEmpty(videoSettings) && _.isTruthy(videoSettings.thumbnail_url) ? videoSettings.thumbnail_url.replace('http://', 'https://') : null;
        },
        /**
         * @deprecated
         * TODO: Currently, we use this function to display images of all sizes everywhere, both in CP + Photos
         *      which is a bit counterintuitive since not all the cases we 're using this function, are we expecting it to be a thumbnail
         *      in reality, we should have separate functions for sizes, instead of passing it as a parameter
         *
         * Note: this should ONLY be used for approved photos
         * Non approved photos dont guarantee to have our pixlee CDN versions due to costs and processing power
         * @param {string} size
         */
        thumbnail: function(size) {
            // If there is a custom video thumbnail, return it
            var videoThumbnail = this.getCustomVideoThumbnail();
            if (videoThumbnail) {
                return videoThumbnail;
            }

            // First try to use photoFileURL if we believe it to exist
            if (this.data_file_name && (this.approved || this.resized)) {
                return this.photoFileURL(size);
            }

            // try to get a non photoFileURL thumbnail
            var thumbnail = (this.medium_url || this.thumbnail_url || this.source_url || '').replace('http://', 'https://');

            // As a final fall back, return photoFileURL if thumbnail is blank
            return thumbnail || this.photoFileURL(size);
        },
        showDate: function() {
            if (gon.display_options.showTimestampsOnPhotowall) {
                return true;
            }
            return false;
        },
        getDate: function() {
            return dayjs(this.tagged_at).format('MM/DD/YYYY');
        },
        getCaption: function() { //puts the caption of the image in the caption box if it has a caption
            return this.caption || '';
        },
        getUploaderProductInput: function() {
            return this.uploader_product_input || '';
        },
        requiredCaptions: function() { //display option from design editor indicating whether the caption for the uploaded item is required or not
            return _.isTruthy(App.displayOptions.get('requiredCaptions'));
        },
        isDefaultCaptionPlaceholder: function() {
            // check if text saved in the Display Options matches the default English value
            return (
                App.displayOptions.get('captionPlaceholder') ===
                I18n.translations.en.uploader.review_submission.caption_placeholder
            );
        },
        captionPlaceholder: function() { // returns the caption placeholder value from the design editor or the default value
            return App.displayOptions.get('captionPlaceholder') || 'Write a caption...';
        },
        isDefaultProductPlaceholder: function() {
            var placeholder = (
                App.displayOptions.get('productFieldName').toUpperCase() + ' ' +
                App.displayOptions.get('productFieldPlaceholder')
            );
            // check if text saved in the Display Options matches the default English value
            return placeholder === I18n.translations.en.uploader.review_submission.product_placeholder;
        },
        productFieldEnabled: function() { // if true, the review section of the uploader will have an additional text field where the user can input more information about the product in the image they are uploading
            return App.displayOptions.get('enableProductField');
        },
        productPlaceholder: function() { // returns the placeholder for the product information field, or the default if the person who made the widget didn't specify a custom placeholder value
            return (
                (App.displayOptions.get('productFieldName').toUpperCase() || 'PRODUCT:') + ' ' +
                (
                    App.displayOptions.get('productFieldPlaceholder') ||
                    'Adding the product name, URL or location helps with getting your content featured!'
                )
            );
        },
        decode_utf8: function(s) { //decodes a string
            return App.request('decode:untrusted:input', s);
        },
        shouldShowProductBadges: function() {
            // TODO 03/25/2021: double check that this actually works
            // The vote button overrides the product badge
            return !this.isPartOfCampaign() && this.hasProducts() && !!gon.display_options.productBadgeLayout;
        },
        // Whether or not we should show the vote button
        isPartOfCampaign: function() {
            // This is a boolean
            return gon.current_album.campaign;
        },
        hasProducts: function() {
            return this.products && this.products.length > 0;
        },
        getProductBadgeClasses: function() {
            var layout = gon.display_options.productBadgeLayout;
            var classes = {
                black_bg_white_solid: 'circle_icon white filled_bag',
                white_solid: 'white filled_bag black_shadow',
                black_solid: 'black filled_bag white_shadow',
                black_bg_white_outline: 'circle_icon white regular_bag',
                black_bg_white_light: 'circle_icon white light_bag',
                black_outline: 'black regular_bag',
                black_light: 'black light_bag'
            };
            return classes[layout] || '';
        },
        showIncentivizedBadge: function() {
            // If the content is tagged with a category of "incentivized" then its incentivized content
            // The gallery must also have the incentivized display option enabled
            var isIncentivized = _.some(this.categories, function(category) {
                return category.toLowerCase() === 'incentivized';
            });
            return isIncentivized && gon.display_options.showIncentivizedBadge;
        },
        // Override photo quality with display option photoQuality
        getPhotoQuality: function(defaultQuality) {
            var opts = ['medium', 'xl', 'original'];
            var selectedQuality = gon.display_options.photoQuality;
            // If the selected quality is not part of the mappable options, return default for the template
            if (!_.contains(opts, selectedQuality)) {
                return defaultQuality;
            }
            return selectedQuality;
        }
    };
    Concerns.PhotoViewHelpers = {
        templateHelpers: templateHelpers
    };
    Concerns.PhotoHelpers = templateHelpers;
});
